import Chip from '@components/v2/ui/Chip/Chip';
import LangEnum from '../../../../../../../../../../lang/LangEnum';
import { useTranslation } from '../../../../../../../../../../modules/translation/TranslationContext';

const SidebarNavItemNewChip = () => {
  const { translate } = useTranslation();

  return (
    <Chip
      size="extraSmall"
      label={translate(LangEnum.GLOBAL_NEW)}
      sx={(theme) => ({
        backgroundColor: theme.palette.accent.main,
        color: theme.palette.accent.contrastText,
      })}
    />
  );
};

export default SidebarNavItemNewChip;
